import { IApiResult, IResult } from './IResult'

class Transformer {
    static transform (apiData: IApiResult): IResult {
        return {
            customerId: apiData.customer_id,
            firstName: apiData.first_name,
            lastName: apiData.last_name,
            total: apiData.total
        }
    }
}

export default Transformer
